import React, { Component, useContext, useEffect, useRef, useState } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, formatDate, SubmitButton, IconButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
// import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import Select from 'react-select';
import ToggleSwitch from '../../Components/ToggleSwitch';
import { NoRecords } from '../../Components/Shimmer';
import { currentDateAndTime } from '../../Constants/Constants';
import Switch from "react-switch";

const AssignModule = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON } = useContext(ConfigContext);
    const sourceDivRef = useRef(null); // Ref for the source div
    const [targetDivHeight, setTargetDivHeight] = useState("auto")
    const [rows, setRows] = useState([]);
    const [parentHeaderRows, setParentHeaderRows] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [permissionsData, setPermissionsData] = useState([]);
    const [moduleId, setModuleId] = useState("");
    const [isChanged, setIsChanged] = useState(false);
    const [assignModuleModal, setAssignModuleModal] = useState(false);
    const [loadingPost, setLoadingPost] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [moduleData, setModuleData] = useState([]);
    const [originalModuleData, setOriginalModuleData] = useState([]);
    const [formData, setFormData] = useState({
        companyId: "",
        headerList:"",
        headerName: "",
        headerPath: "",
        headerStatus: "0",
        parentId: null,
    });
    const [errors, setErrors] = useState({});
    const [editableRow, setEditableRow] = useState(null);
    const [permissionRowData, setPermissionRowData] = useState(null);


    const getList = () => {
        const headers = apiHeaderJSON || { 'Content-Type': "application/json", token: `${localStorage.getItem("token_master")}`, 'x-company-id': localStorage.getItem("company_id_master"), 'x-user-id': localStorage.getItem("user_id_master") };
        // console.log("headers =>",headers);
        axios.get(`${apiURL}CompanyMasters/GetHeaderList`, {
        // axios.get(`${apiURL}CompanyMasters/GetHeaderPermissionList`, {
            params: {
                user_id: localStorage.getItem("user_id_master"),
                companyId: formData?.companyId
            }, headers
        }).then((response) => {
            let data = response.data;
            // console.log(data);
            if (response.data.success === true) {
                let rows = data?.header_list?.map((val) => {
                    return { value: val?.module_id, label: val?.header_name }
                });
                rows.unshift({ value: "All", label: "All" });
                setParentHeaderRows(rows);
                // setRows(data?.header_list);
            }
        }).catch((error) => {
            console.error("error", error);
        });
    }
    const getAssignModuleList = () => {
        const headers = apiHeaderJSON || { 'Content-Type': "application/json", token: `${localStorage.getItem("token_master")}`, 'x-company-id': localStorage.getItem("company_id_master"), 'x-user-id': localStorage.getItem("user_id_master") };
        // console.log("headers =>",headers);
        Swal.fire({
            title: 'Please wait...',
            html: 'Loading...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        axios.get(`${apiURL}CompanyMasters/GetAssignedModules`, {
            params: {
                user_id: localStorage.getItem("user_id_master"),
                companyId: formData?.companyId
            }, headers
        }).then((response) => {
            const data = response.data;
            // console.log(data);
            if (response.data.success === true) {
                const idList = data?.header_list?.map(item => item.module_id).join(",")
                setFormData({
                    ...formData,
                    headerList:idList,
                });
            } else {
                // setParentHeaderRows([]);
                setRows([]);
                setFormData({
                    ...formData,
                    headerList:[],
                });
                console.error("Error fetching list");
            }
            Swal.close();
        }).catch((error) => {
            Swal.close();
            console.error("error", error);
        });
    }
    const getAssignList = () => {
        const headers = apiHeaderJSON || { 'Content-Type': "application/json", token: `${localStorage.getItem("token_master")}`, 'x-company-id': localStorage.getItem("company_id_master"), 'x-user-id': localStorage.getItem("user_id_master") };
        // console.log("headers =>",headers);
        axios.get(`${apiURL}CompanyMasters/GetHeaderPermissionList`, {
            params: {
                user_id: localStorage.getItem("user_id_master"),
                companyId: formData?.companyId
            }, headers
        }).then((response) => {
            let data = response.data;
            // console.log(data);
            if (response.data.success === true) {
                setModuleData(data?.result);
                setOriginalModuleData(data?.result);
                setRows(data?.result);
                // if (sourceDivRef.current) {
                //     const sourceHeight = sourceDivRef.current.offsetHeight;
                //     setTargetDivHeight(`${sourceHeight}px`);
                // }
            } else {
                // setParentHeaderRows([]);
                setRows([]);
                setOriginalModuleData([]);
                setModuleData([]);
                console.error("Error fetching list");
            }
        }).catch((error) => {
            console.error("error", error);
        });
    }

    useEffect(() => {
        const sourceDiv = sourceDivRef.current;

        if (sourceDiv) {
            const resizeObserver = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    // Update the target div height whenever the source div resizes
                    setTargetDivHeight(`${entry.contentRect.height}px`);
                }
            });

            // Observe the source div for resizing
            resizeObserver.observe(sourceDiv);

            return () => {
                // Clean up observer on component unmount
                resizeObserver.disconnect();
            };
        }
    }, []);

    const getCompanies = () => {
        const headers = apiHeaderJSON || { 'Content-Type': "application/json", token: `${localStorage.getItem("token_master")}`, 'x-company-id': localStorage.getItem("company_id_master"), 'x-user-id': localStorage.getItem("user_id_master") };
        // console.log("headers =>",headers);
        axios.get(`${apiURL}CompanyMasters/getCompanies`, {
            params: {
            }, headers
        }).then((response) => {
            let data = response.data;
            // console.log(data);
            if (response.data.success === true) {
                let rows = data?.companies?.map((val,idx) => {
                    return  { value: val?.company_id, label: val?.company_name }
                });
                setCompanyOptions(rows);
                
            } else {
                console.error("Error fetching list");
            }
        }).catch((error) => {
            console.error("error", error);
        });
    }

    useEffect(() => {
        if (!isChanged) {
            return;
        }
        getAssignList();
        getAssignModuleList();
        setIsChanged(false);
        // setPermissionRowData(null);
        setEditableRow(null);  
    }, [isChanged]); 

    useEffect(() => { 
        getList();
        getCompanies(); 
    }, []); 

    const handleChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    }
    const handleSlabMultiSelect = (fieldName, selectedOptions) => {

        console.log("selectedOptions",selectedOptions);

        if (selectedOptions.some(option => option.value === "All")) {
            const ids = parentHeaderRows ? parentHeaderRows
                    .filter(option => option.value !== "All")
                    .map(option => option.value)
                    : [];
            console.log(ids.join(','));
            setFormData((prevFormData) => ({
                ...prevFormData,
                [fieldName]: ids.join(','),
            }));
            return;
        }
        const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setFormData((prevFormData) => ({
            ...prevFormData,
            [fieldName]: ids.join(','),
        }));
    };
     
    
    // const handleSlabMultiSelect = (index, fieldName, selectedOptions) => {
    //     let allList="";
    //     parentHeaderRows?.forEach((val)=>{
    //         allList= allList + `${val?.value}`
    //     });

    //     if ((Array.isArray(selectedOptions) && selectedOptions?.find((val) => val?.value === "All")) || selectedOptions?.value === "All") {
    //         setFormData(prevSlabRows => prevSlabRows.map((row, rowIndex) =>
    //             rowIndex === index
    //                 ? {
    //                     ...row,
    //                     [fieldName]: allList, // Join the selected months as a comma-separated string
    //                 }
    //                 : row // Return the row as is if it is not the targeted index
    //         ));
    //     }
    //     else {
    //         // Extract the selected month values or set an empty array if no options are selected
    //         const header = selectedOptions?.map(option => option.value) || [];

    //         // Create a shallow copy of slabRows to avoid directly mutating the state
    //         setFormData(prevSlabRows => prevSlabRows.map((row, rowIndex) =>
    //             rowIndex === index
    //                 ? {
    //                     ...row,
    //                     [fieldName]: header.join(","), // Join the selected months as a comma-separated string
    //                 }
    //                 : row // Return the row as is if it is not the targeted index
    //         ));
    //     }
    // };

    // const handleToggleSwitch = () => {
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         headerStatus: formData?.headerStatus == "1" ? "0" : "1",
    //     }));
    // };

    const getInfo = (id) => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}CompanyMasters/GetHeaderInfo`,
            {
                params: {
                    moduleId: id
                },
                headers
            }).then((response) => {
                const { success, result } = response.data;
                // console.log(response?.data);
                if (success === true) {
                    setFormData({
                        ...formData,
                        module_id: result[0]?.module_id,
                        headerName: result[0]?.header_name,
                        headerPath: result[0]?.header_path,
                        headerStatus: result[0]?.header_status || "0",
                        parentId: result[0]?.parent_id,
                    });

                } else {

                }
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        // const errors = validateForm();
        // console.log("errors 1", errors);
        // if (Object.keys(errors).length > 0) {
        //     setErrors(errors);
        //     return;
        // }
        let check= formData?.headerList?.split(",")
        .filter(value => value.trim() !== "All") // Remove "All"
        .join(","); 
        setLoadingPost(true);
        let data = {
            headerList: check,
            date: currentDateAndTime(),
        }

        const headers = apiHeaderJSON || { 'Content-Type': "application/json", token: `${localStorage.getItem("token_master")}`, 'x-company-id': localStorage.getItem("company_id_master"), 'x-user-id': localStorage.getItem("user_id_master") };
        // console.log("formData?.companyId", formData?.companyId);
        // console.log("handleSubmit ~ form Data =======>>>", formData);
        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        axios
            .post(`${apiURL}CompanyMasters/AssignModules`, data, {
                params: {
                    user_id: localStorage?.getItem("user_id_master"),
                    companyId: formData?.companyId
                },
                headers,
            })
            .then((response) => {
                const { success, } = response.data;
                // console.log("handleSubmit ~ response =======>>>", response);
                if (success === true) {

                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true, 
                        allowOutsideClick:false
                    });
                    setFormData({
                        companyId: formData?.companyId,
                        // headerList:"",
                        headerName: "",
                        headerPath: "",
                        headerStatus: "0",
                        parentId: "",
                    });
                    getAssignList();
                    getAssignModuleList();
                    setLoadingPost(false);
                    setAssignModuleModal(false);
                    Swal.close();
                } else {
                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true, 
                        allowOutsideClick:false
                    });
                    setLoadingPost(false);

                }
            });
    }

    const handleCheckboxChange = (value, module) => {
        console.log("value, module ==>", value, module);
        let permissionsTemp = [...permissionsData];
    
        if (permissionsTemp.includes(value)) {
            permissionsTemp = permissionsTemp.filter(val => val !== value);
        } else {
            permissionsTemp.push(value);
        }
        setPermissionsData(permissionsTemp);
        // // Parse the permissions
        // const updatedPermissions = JSON.parse(module.header_permissions);
        // console.log("modules before ===>", moduleData);
    
        // // Determine new permissions (add or remove)
        // const newPermissions = updatedPermissions.includes(value)
        //     ? updatedPermissions.filter((item) => item !== value) // Remove if exists
        //     : [...updatedPermissions, value]; // Add if not exists
    
        // // Create a new updated module object
        // const updatedModule = {
        //     ...module,
        //     header_permissions: JSON.stringify(newPermissions), // Update the permissions
        // };
        
        // // Update the moduleData by finding the correct module and modifying it
        // setModuleData((prevModuleData) => {
        //     const updatedModuleData = prevModuleData.map((mod) => {
        //         if (mod.header_id === updatedModule.header_id) {
        //             return updatedModule; // Replace the module with the updated one
        //         }
        //         return mod; // Keep the other modules unchanged
        //     });
        //     return updatedModuleData;
        // });
    
        // setPermissionRowData(updatedModule);
    };
    
    // const handleEdit = (rowName) => {
    //     setModuleData(originalModuleData);  
    //     setEditableRow(rowName);  
    // };
    const handleEdit = (row) => {
        console.log("row",row);
        setPermissionsData(JSON.parse(row?.header_permissions));
        setModuleData(originalModuleData);  
        setEditableRow(row?.name);  
        setModuleId(row?.header_id);
    };
    
    const handlePermission = () => {
         
        let data = {
            module_id: moduleId,
            header_permissions: JSON.stringify(permissionsData),
            date: currentDateAndTime(),
        }

        // console.log("handlePermission ~ data =======>>>", data);

        const headers = apiHeaderJSON || { 'Content-Type': "application/json", token: `${localStorage.getItem("token_master")}`, 'x-company-id': localStorage.getItem("company_id_master"), 'x-user-id': localStorage.getItem("user_id_master") };
        
        axios
            .post(`${apiURL}CompanyMasters/HandleModulePermission`, data, {
                params: {
                    user_id: localStorage?.getItem("user_id_master"),
                    companyId: formData?.companyId
                },
                headers,
            })
            .then((response) => {
                const { success, } = response.data;
                // console.log("handlePermission ~ response =======>>>", response);
                if (success === true) {

                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true, 
                        allowOutsideClick:false
                    });
                    
                    getAssignList();
                    setEditableRow(null);  
                    setPermissionsData([]);
                    setModuleId(false); 
                } else {
                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true, 
                        allowOutsideClick:false
                    });
                }
                setLoadingSave(false);
            })
            .catch((error)=>{
                setLoadingSave(false);
                console.error(error);
            });
    };

    const handleCancel = () => {
        setModuleData(originalModuleData);  
        setEditableRow(null);  
        setPermissionsData([]);
        setModuleId(false);
    };

    const handleToggleSwitch = (moduleId, toggleButton) => {

        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to change header status to ${toggleButton ? "On" : "Off"}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
        }).then((result) => {
            if (result.isConfirmed) {
                let data = {
                    moduleId: moduleId,
                    header_status: toggleButton ? "1" : "0",
                    date: currentDateAndTime(),
                }
                const headers = apiHeaderJSON;
                // setToggleButton(!toggleButton);
                // console.log(data);
                axios
                    .post(`${apiURL}CompanyMasters/HandleModuleStatus`, data, {
                        params:{
                            user_id: localStorage.getItem("user_id_master"),
                            companyId: formData?.companyId
                        },
                        headers,
                    })
                    .then((response) => {
                        const { success } = response.data;
                        // console.log("handleToggleSwitch ~ response =======>>>", response);
                        if (success === true) {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true, 
                                allowOutsideClick:false
                            });
                            
                            getAssignList(false);
                        } else {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true, 
                                allowOutsideClick:false
                            });
                        }
                    });
            }
            // else {
            //     Swal.fire({
            //         title: 'Cancelled',
            //         text: 'Cancelled..',
            //         icon: 'info',
            //         timer: 1500,
            //         showConfirmButton: false
            //     });
            //     return; // Do nothing if the user cancels
            // }
        });

    }
    const [expandedRows, setExpandedRows] = useState({});

    const toggleRow = (moduleName) => {
        setExpandedRows((prev) => ({
            ...prev,
            [moduleName]: !prev[moduleName],
        }));
    };

const renderRows = (modules, parentName = null, level = 0) => {
    return modules.map((module) => (
        <React.Fragment key={module.name}>
            <tr>
                <td style={{ paddingLeft: `${level * 30}px` }}>
                    <div className=' ps-2 d-flex align-items-center'>
                    
                        <button
                        // disabled={!module.sub_module}
                        // ${!module.sub_module? "light":"primary" }
                            className={`btn btn-xs py-0 px-0 ${!module.sub_module? "ms-2 me-2 cursorDefault":"me-1"} `}
                            onClick={() => {if(module.sub_module) toggleRow(module.name);}}
                        >
                            <i className={` text-${!module.sub_module? "dark":"primary" } ${!module.sub_module? "ri-checkbox-blank-circle-fill cursorDefault fs-10" : expandedRows[module.name] ? "ri-arrow-down-s-fill cursorPointer fs-24" : "ri-arrow-right-s-fill cursorPointer fs-24"} label-icon align-middle`} />
                        </button>
                        {module.name}
                    </div>
                </td>
                <td>{parentName || '--'}</td>
                <td>
                    <ToggleSwitch
                        isActive={module?.header_status == '1'}
                        isExtFunc={true}
                        onToggle={() =>
                            handleToggleSwitch(module.header_id, module.header_status == "1" ? false : true)
                        }
                    />
                </td>
                   {/* permissions */}
                  <td  >
                    <div className='ps-2 d-flex justify-content-around'>
                        <div className={`d-flex justify-content-center align-items-center gap-2 p-1 border rounded shadow-sm ${editableRow !== module.name && 'text-muted'}`}>
                           <p className="mb-0">View</p>
                           {/* <input
                                type="checkbox"
                                checked={JSON.parse(module?.header_permissions).includes(1)}
                                onChange={() =>
                                    handleCheckboxChange(1, module)
                                }
                                disabled={editableRow !== module.name}
                            /> */}
                            <Switch
                                checked={editableRow === module.name ? permissionsData?.includes(1) : JSON.parse(module?.header_permissions).includes(1)}
                                onChange={() => handleCheckboxChange(1, module)}
                                disabled={editableRow !== module.name}
                                height={20}
                                width={40}
                                handleDiameter={16}
                                onColor="#3CD188"
                                offColor="#ccc"
                            />
                        </div>
                   
                        <div className={`d-flex justify-content-center align-items-center gap-2 p-1 border rounded shadow-sm  ${editableRow !== module.name && 'text-muted'}`}>
                           <p className="mb-0">Add</p>
                             <Switch
                                checked={editableRow === module.name ? permissionsData?.includes(2) : JSON.parse(module?.header_permissions).includes(2)}
                                onChange={() => handleCheckboxChange(2, module)}
                                disabled={editableRow !== module.name}
                                height={20}
                                width={40}
                                handleDiameter={16}
                                onColor="#3CD188"
                                offColor="#ccc"
                            />
                        </div>
                        <div className={`d-flex justify-content-center align-items-center gap-2 p-1 border rounded shadow-sm  ${editableRow !== module.name && 'text-muted'}`}>
                           <p className="mb-0">Edit</p>
                            
                             <Switch
                                checked={editableRow === module.name ? permissionsData?.includes(3) : JSON.parse(module?.header_permissions).includes(3)}
                                onChange={() => handleCheckboxChange(3, module)}
                                disabled={editableRow !== module.name}
                                height={20}
                                width={40}
                                handleDiameter={16}
                                onColor="#3CD188"
                                offColor="#ccc"
                            />
                        </div>
                        <div className={`d-flex justify-content-center align-items-center gap-2 p-1 border rounded shadow-sm  ${editableRow !== module.name && 'text-muted'}`}>
                           <p className="mb-0">Delete</p>
                           <Switch
                                checked={editableRow === module.name ? permissionsData?.includes(4) : JSON.parse(module?.header_permissions).includes(4)}
                                onChange={() => handleCheckboxChange(4, module)}
                                disabled={editableRow !== module.name}
                                height={20}
                                width={40}
                                handleDiameter={16}
                                onColor="#3CD188"
                                offColor="#ccc"
                            />
                        </div>
                        <div className={`d-flex justify-content-center align-items-center gap-2 p-1 border rounded shadow-sm  ${editableRow !== module.name && 'text-muted'}`}>
                           <p className="mb-0">Logs</p>
                           <Switch
                                checked={editableRow === module.name ? permissionsData?.includes(5) : JSON.parse(module?.header_permissions).includes(5)}
                                onChange={() => handleCheckboxChange(5, module)}
                                disabled={editableRow !== module.name}
                                height={20}
                                width={40}
                                handleDiameter={16}
                                onColor="#3CD188"
                                offColor="#ccc"
                            />
                        </div>
                        <div className={`d-flex justify-content-center align-items-center gap-2 p-1 border rounded shadow-sm  ${editableRow !== module.name && 'text-muted'}`}>
                           <p className="mb-0">Excel</p>
                           <Switch
                                checked={editableRow === module.name ? permissionsData?.includes(6) : JSON.parse(module?.header_permissions).includes(6)}
                                onChange={() => handleCheckboxChange(6, module)}
                                disabled={editableRow !== module.name}
                                height={20}
                                width={40}
                                handleDiameter={16}
                                onColor="#3CD188"
                                offColor="#ccc"
                            />
                        </div>
                    </div>
                </td>  
                {/* Action Buttons */}
                <td>
                    <div className='d-flex justify-content-around gap-2'>
                        {editableRow === module.name ? (
                            // <button className="btn-icon btn btn-sm btn-success" onClick={() =>{setLoadingSave(true); handlePermission();}}>
                            //     <i className='ri-save-line'/> 
                            // </button>
                            <IconButton 
                             loading={loadingSave}
                             onClick={() => {setLoadingSave(true); handlePermission();}} type='success' icon='ri-save-line' tooltipName='Save' tooltipPosition='bottom' />
                        ) : (
                            // <button className="btn-icon btn btn-sm btn-info" onClick={() => handleEdit(module)}>
                            //     <i className='ri-edit-line' /> 
                            // </button>
                            <IconButton 
                            onClick={() => { handleEdit(module);}} type='info' icon='ri-edit-line' tooltipName='Edit' tooltipPosition='bottom' />
                        )}
                        {editableRow === module.name && (
                            // <button className="btn-icon btn btn-sm btn-danger" onClick={handleCancel}>
                            //     <i className='ri-close-circle-line'/>  
                            // </button>
                            <IconButton 
                            onClick={() => { handleCancel();}} type='danger' icon='ri-close-circle-line' tooltipName='Cancel' tooltipPosition='bottom' />
                        )
                        }
                    </div>
                   
                </td>
            </tr>
            {expandedRows[module.name] &&
                module.sub_module &&
                renderRows(module.sub_module, module.name, level + 1)}
        </React.Fragment>
    ));
};
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Module Master`} primary={`Home`} />
                    <div className="row card">
                        {/* <div className=' col-md-12'>
                            <div className="  col-md-5 mt-3 mb-3">
                                <label>Select Company</label>
                                <Select
                                    onChange={(selectedOption) => { setIsChanged(true); setFormData({ ...formData, companyId: selectedOption?.value })}}
                                    placeholder={`Select Company`}
                                    options={companyOptions}
                                    value={formData?.companyId ? companyOptions.find(option => option.value === formData?.companyId) : null}
                                />
                                {errors.companyId && <div className="text-danger">{errors.companyId}</div>}
                            </div>
                        </div> */}
                        
                        <div  className=' card-body'>
                            <div className=' card-header' >
                                <div className='row'>
                                    <div className=' col-md-6 position-relative mb-5'>
                                        {/* <div className=" mx-3 mt-2 mb-1 "> */}
                                            <label>Select Company</label>
                                            <div className=' position-absolute z-2 w-100 pe-3' >
                                                <Select
                                                    onChange={(selectedOption) => { setIsChanged(true); setFormData({ ...formData, companyId: selectedOption?.value }) }}
                                                    placeholder={`Select Company`}
                                                    options={companyOptions}
                                                    value={formData?.companyId ? companyOptions.find(option => option.value == formData?.companyId) : null}
                                                />
                                            </div>
                                            {errors.companyId && <div className="text-danger">{errors.companyId}</div>}
                                        {/* </div> */}
                                    </div>
                                    <div className=' col-md-3'>
                                        <div>
                                            <label className="form-label">Assign Module</label>
                                        </div>
                                        <SubmitButton disabled={!formData?.companyId} buttonName='Assign' type='primary' icon='ri-save-line' onClick={()=>{ setAssignModuleModal(true); }} />
                                    </div>
                                </div>
                                
                            </div>
                            <div className=" mt-3">
                                <div style={{ "overflowX": "auto" }}>
                                    {/* <table className={`position-relative table table-bordered table-stripped `}>
                                        <thead className='table-light sticky-top z-1'>
                                            <tr>
                                                <th>Header Name</th>
                                                <th>Header Path</th>
                                            
                                                <th>Status</th>
                                            
                                            </tr>
                                        </thead>
                                        {rows?.length === 0 ?
                                            <tbody>
                                                <tr>
                                                    <td colSpan={5}>
                                                        <NoRecords />
                                                    </td>
                                                </tr>
                                            </tbody> :
                                            <tbody>
                                                {
                                                    rows?.map((row) => {
                                                        return <tr key={row?.module_id}>
                                                            <td>{row?.header_name}</td>
                                                            <td>{row?.header_path || "--"}</td>
                                                            <td>{row?.parent_header_name || "--"}</td>
                                                            <td className=' text-center'>
                                                                    {row?.header_status == '1' ? <span style={{ borderRadius:"5px", fontWeight:"700"}} className=' py-1 px-2 bg-success text-white'>On</span>:<span style={{ borderRadius:"5px", fontWeight:"700"}} className=' py-1 px-2 bg-warning text-white'>Off</span> } 
                                                                <ToggleSwitch isActive={row?.header_status == '1'} isExtFunc={true} onToggle={() => { handleToggleSwitch(row.module_id, row?.header_status == "1" ? false : true) }} />
                                                            </td>
                                                            <td className='d-flex justify-content-around'>
                                                                    <button type='button' onClick={() => { setFormData({ ...formData, module_id: row?.module_id }); getInfo(row?.module_id) }} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button> 
                                                                    <button onClick={() => this.handleDelete(row.leave_type_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button> 
                                                                    <button type='button' onClick={() => this.setState({ leave_type_id: row.leave_type_id }, (prevState) => this.GetInfo())} className="btn-icon btn btn-sm btn-outline-info" data-bs-toggle="modal" data-bs-target="#myModal"> <i className="mdi mdi-view-list-outline fs-4"></i> </button> 
                                                            </td>
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                        }

                                    </table> */}
                                    <table style={{ width: "auto", minWidth: "100%"}} 
                                    className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative">
                                        <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                            <tr>
                                                <th>Module Name</th>
                                                <th className='noWrap'>Parent Name</th>
                                                <th>Status</th>
                                                <th className='text-center'>Permissions</th> 
                                                <th>Action</th> 
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {moduleData.length === 0 ? (
                                                <tr>
                                                    <td colSpan={5}>
                                                        <NoRecords />
                                                    </td>
                                                </tr>
                                            ) : (
                                                renderRows(moduleData)
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    {assignModuleModal && (
                            <div className="modal show" 
                                style={{
                                    display: "block",
                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                }} >
                                <div className="modal-dialog modal-xl">
                                    <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalgridLabel">{"Assign Modules"}</h5>
                                        <button type="button"
                                        disabled={loadingPost} className="btn-close" 
                                        onClick={()=>{
                                            setAssignModuleModal(false);
                                        }} aria-label="Close" />
                                    </div>
                                    <div className="modal-body">
                                        <div className="card-body">
                                        <form onSubmit={handleSubmit} className="row">
                                            <div className="col-md-12">
                                                <label>Modules</label>
                                                <Select
                                                    onChange={(selectedOptions) => handleSlabMultiSelect("headerList", selectedOptions)}
                                                    placeholder={parentHeaderRows?.length>0?"Select Modules":"None"}
                                                    isMulti
                                                    className={`${errors.headerList ? "is-invalid" : ""}`}
                                                    options={parentHeaderRows}
                                                    value={formData.headerList ? formData.headerList.split(',').map(id => parentHeaderRows.find(option => option.value == id)) : null}
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            borderColor: errors?.headerList ? "red" : base.borderColor,
                                                            boxShadow: errors?.headerList ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                                            "&:hover": {
                                                                borderColor: errors?.headerList ? "red" : base.borderColor,
                                                            },
                                                        }),
                                                    }}
                                                />
                                                {errors.headerList && <div className="text-danger">{errors.headerList}</div>}
                                            </div>
                                            <div className="col-md-3 mt-3">
                                                {/* <button
                                                    disabled={!formData?.companyId || loadingPost}
                                                    type="submit"
                                                    className={`btn btn-primary btn-label waves-effect right waves-light float-right mt-3`}
                                                >
                                                    <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                    {!loadingPost ? "Assign Module" : "Loading..."}
                                                </button> */}
                                                <SubmitButton disabled={!formData?.companyId || loadingPost} buttonName='Assign'  type='primary' icon='ri-save-line' />
                                            </div>
                                        </form>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        )}
                </div>
            </div>

        </div>
    );
}

export default AssignModule;
